import { render } from "./RegulatoryView.vue?vue&type=template&id=00ee3704"
import script from "./RegulatoryView.vue?vue&type=script&lang=js"
export * from "./RegulatoryView.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__